import { Variants } from '../types/variant';

/**
 * PROM ARS — questionnaires de mesure du résultat rapporté par le patient
 * (Patient-Reported Outcome Measures) demandés par l'ARS en post-consultation.
 *
 * Premier périmètre : le KCCQ-12 (Kansas City Cardiomyopathy Questionnaire),
 * qui mesure le retentissement de l'insuffisance cardiaque. C'est un
 * questionnaire autoportant — le patient y répond après sa consultation, pas
 * pour la préparer — d'où l'onboarding dédié `PROM_ARS`, qui retire l'étape
 * « why-prepare » et reformule l'accueil.
 *
 * Pas de compte rendu à ce stade : `QUESTIONS_ANSWERS` restitue simplement les
 * questions et les réponses. Les scores par domaine et surtout leur évolution
 * entre deux passations (≥ 5 points = changement cliniquement significatif)
 * restent à construire.
 */
export const promArsVariants = {
  prom_ars: {
    name: 'PROM ARS',
    status: 'alpha',
    description:
      "Questionnaire de suivi post-consultation demandé par l'ARS. Contient le KCCQ-12, qui mesure le retentissement de l'insuffisance cardiaque (12 items, environ 5 minutes).",
    speciality: 'PROM-ARS',
    patientOnboarding: 'PROM_ARS',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'QUESTIONS_ANSWERS',
    initialQuestions: [],
    pages: {
      KCCQ12: {
        title: "Vécu de l'insuffisance cardiaque",
        sections: ['KCCQ12'],
      },
    },
    initialAssertions: [],
    options: [],
  },
} satisfies Variants;
